'use client';

import { c as _c } from "react/compiler-runtime";
import { X, Flame } from 'lucide-react';
import Link from 'next/link';
import { useEarlyPreviewDismiss } from '@/components/EarlyPreviewProvider';
export function EarlyPreviewBanner() {
  const $ = _c(7);
  const dismiss = useEarlyPreviewDismiss();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Flame className="w-4 h-4 flex-shrink-0 hidden sm:block" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="hidden sm:inline">Early Preview — </span>;
    t2 = <span className="sm:hidden">Early Preview - </span>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-center font-medium">{t1}{t2}{" "}<Link href="/early-preview" className="underline hover:no-underline cursor-pointer">Learn more</Link></p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <X className="w-4 h-4" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== dismiss) {
    t5 = <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-primary-600 to-primary-500 text-white"><div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-2 flex items-center justify-center gap-2 text-sm relative">{t0}{t3}<button onClick={dismiss} className="absolute right-2 sm:right-4 p-1 rounded-md hover:bg-white/20 transition-colors cursor-pointer" aria-label="Dismiss banner">{t4}</button></div></div>;
    $[5] = dismiss;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}